import FilterModel from '../filter/data/filter.model.js'

var METRIC_TAG_LIST_FILTER_KEY = 'METRIC_TAG_LIST';

export default {
    getApiReadyQueryTagFilters: function (filterExpression) {
        let model = new FilterModel();
        model.setActiveFilters(filterExpression);
        return decodeURIComponent(model.getActiveFiltersString());
    },

    getMigratedMetricName: function (metricId, categoryId, kpiId) {
        if (metricId) {
            return metricId;
        }

        //  These metrics are not necessarily tight to one specific type of system/infrastructure (bridge or call control).
        var generalMetrics = [
            'meetings',
            'participants',
            'hd.port.licenses.used',
            'hardware',
            'hd.port.licenses.used.percent',
            'traversal.calls',
            'nontraversal.calls',
            'traversal.calls.used.percent',
            'nontraversal.calls.used.percent',
            'registered'
        ];

        var name = kpiId;
        if (!_.includes(generalMetrics, name)) {
            name = categoryId + '.' + kpiId;
        }
        return name;
    },

    migrate: function (params) {
        this.migrateKpiIdToMetricId(params);
        this.migrateTrunkMetrics(params);
    },

    migrateTrunkMetrics: function (params) {
        if (params.options.categoryId === 'trunk') {
            if (params.options.metricId === 'trunk.status.up' ||
                params.options.metricId === 'trunk.status.down' ||
                params.options.metricId === 'trunk.status.none'
                ) {
                params.options.modelId = 'all';
            } else if (params.options.metricId === 'trunk.calls'
                ) {
                params.options.modelId = 'CUBE';
            }

        }
    },

    migrateKpiIdToMetricId: function (params) {
        if (params.options.kpiId) {
            if (!params.options.metricId) {
                params.options.metricId = this.getMigratedMetricName(params.options.metricId, params.options.categoryId, params.options.kpiId);
                delete params.options.kpiId;
            }

        }
        if (params.options.metricType) {
            // todo add groupBy
            delete params.options.metricType;
        }
    }
};
